// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__t3yki","ball":"styles_ball__xH06n","ball-fall":"styles_ball-fall__aNbpv"};